export default function mapPointHover() {
  const staticMaps = document.querySelectorAll('[data-hp-map]')

  staticMaps.forEach(staticMap => {
    const links = staticMap.querySelectorAll('[data-highlight-link]')
    const [...areas] = staticMap.querySelectorAll('[data-highlight-area]')

    links.forEach(link => {
      link.addEventListener('mouseenter', () => {
        const active = areas.find(
          area => area.dataset.highlightArea === link.dataset.highlightLink
        )
        if (!active) return
        active.classList.add('highlight')
      })
      link.addEventListener('mouseleave', () => {
        areas.forEach(area => area.classList.remove('highlight'))
      })
    })
  })
}
